import React from 'react';
import Bom from "../components/bom/Bom";

const BomPage = () => {
    return (
        <div>
        
            <Bom />
        </div>
    );
};

export default BomPage;
